import { produce } from 'immer';
import { AUTH_LOGOUT } from '../actions';
import {} from '../actions/news';
import { APPROVAL_REQUESTS_GET } from '../actions/eventApproval';

const initialState = {
  newRequests: {
    list: [],
    pager: {},
  },
  oldRequests: {
    list: [],
    pager: {},
  },
  details: {},
};

const eventApprovalReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AUTH_LOGOUT._SUCCESS: {
        draft = initialState;
        break;
      }

      case APPROVAL_REQUESTS_GET._SUCCESS: {
        const { response, pager, newRequests } = action;
        if (newRequests) {
          draft.newRequests.list = response?.items || [];
          draft.newRequests.pager = pager || {};
        } else {
          draft.oldRequests.list = response?.items || [];
          draft.oldRequests.pager = pager || {};
        }
        break;
      }

      default:
        return state;
    }
    return draft;
  });

export default eventApprovalReducer;
